import * as React from "react";
import { v4 } from "uuid";

export function useUniqueIdentifier(prefix: string): string {
  const idRef = React.useRef<string>(`${prefix}-${v4()}`);
  return idRef.current;
}
